import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "../api/axios";
import { clearSession } from "../services/SessionStorage";
import useAuth from "./useAuth";
import { resetActive as resetActiveWinery, empty as emptyWineriesList } from "../context/wineries/wineriesSlice";

const useLogout = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = async () => {
    try {
      const response = await axios.get("/auth/logout", {
        withCredentials: true,
      });
      setAuth({});
      clearSession('authToken');
      // Solo wineries: è l'unico slice che sopravvive come header stantio
      // (wineryid/clientname) sulla prima richiesta del prossimo login.
      // Svuotare qui anche operations/tanks/analysis/ecc. risveglierebbe i
      // guard "if lista vuota, ricarica" delle pagine ancora montate un
      // istante prima che navigate() le smonti, causando una raffica di
      // richieste 401/428 e un login percepito come lento.
      dispatch(emptyWineriesList());
      dispatch(resetActiveWinery());
      navigate("/login");
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  return logout;
};
export default useLogout;
